export const getIndex = (arr, value, field = "productId") => {
  return arr.findIndex((item) => item[field] === value);
};

export const isCart = (str) => str.includes("cart");
export const isPending = (str) => str.includes("pending");
export const isUser = (str) => str.includes("user");
